module.exports = __webpack_public_path__ + "static/img/yifu.41d7315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yifu.png
// module id = 76GH
// module chunks = 4